/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState } from 'react';
import { TextField, Spinner, SpinnerSize } from '@fluentui/react';
import { Link } from "react-router-dom";
import UiCheckbox from '../../UiKit/SharedComponents/UiCheckbox';

const error = (e) => css`
    .ms-TextField-fieldGroup {
        border-color: ${e ? '#ff1f1f' : '#D5DBE4'};
    }
.ms-TextField-errorMessage{
color:#ff1f1f;
padding-top: 0;
}
    `;

const container = css`
    .ms-TextField-errorMessage span {
        color: var(--danger);
        padding-top: 0;
        font-size:14px;
        margin-top: 5px;
    }
    .ms-Label {
        color: #2a2a2a;
        font-weight: 600;
    }
    .continue.ms-Button {
        height: 48px;
        border-radius: 6px;
    background-color: #0b6db8;
    }
    .continue.ms-Button:hover {
        background-color: #005a9e;
        border-color: #005a9e;
    }
        #phoneNumber{
        border:none !important;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset;
        border-radius: 4px !important;
        }
    `;
export default function SignupForm(props) {
    const [email, setEmail] = useState('');
    const [firstName, setFirstname] = useState('');
    const [lastName, setLastname] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState(undefined);
    const [firstNameError, setFirstnameError] = useState(undefined);
    const [lastNameError, setLastnameError] = useState(undefined);
    const [passwordError, setPasswordError] = useState(undefined);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [termsError, setTermsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setEmailError(undefined)
    };
    const handleFirstnameChange = (event) => {
        setFirstname(event.target.value);
        setFirstnameError(undefined)
    };
    const handleLastnameChange = (event) => {
        setLastname(event.target.value);
        setLastnameError(undefined)
    };
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError(undefined)
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        if (loading) return;
        let hasErrors = false;
        if (emailError) {
            hasErrors = true;
        } 
        if (!email) {
            setEmailError("Email Required")
            hasErrors = true;
        } else {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
                setEmailError("Invalid email")
                hasErrors = true;
            }
        }
        if (!firstName) {
            setFirstnameError("First Name Required")
            hasErrors = true;
        }
        if (!lastName) {
            setLastnameError("Last Name Required")
            hasErrors = true;
        }
        if (!password) {
            setPasswordError("Password Required")
            hasErrors = true;
        }
        if (!termsAccepted) {
            setTermsError(true);
            hasErrors = true;
        }
        if (!hasErrors) {
            setLoading(true);
            Promise.resolve(props.callback(email, firstName, lastName, password))
                .finally(() => setLoading(false));
        }
    };

    const password_validate = (password) => {
        var re = {
            capital: /(?=.*[A-Z])/,
            length: /(?=.{7,40}$)/,
            specialChar: /[ -/:-@[-`{-~]/,
            digit: /(?=.*[0-9])/,
        };
        return (
            re.capital.test(password) &&
            re.length.test(password) &&
            re.specialChar.test(password) &&
            re.digit.test(password)
        );
    };

    return (
        <div className=" login-page__form ">
            <h2 className="head-30" >Let's create your account</h2>
            <p className="mb35 mt10">15-day trial, no credit card needed, access all features.</p>
            <form onSubmit={handleSubmit} className="form" css={ container }>
            <div className="form-group">
                <div className="m-b-5" css={error(emailError)}>
                    <TextField
                        errorMessage={emailError}
                        fullWidth
                        id="email"
                        label="Email Address"
                        value={email}
                        onChange={handleEmailChange}
                        styles={{ fieldGroup: { height: '48px', border: 'none', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px inset' }, field: { height: '46px' } }}
                    />
                </div>
                <div className="m-b-5 displayflex" css={error(firstNameError + lastNameError)}>
                    <TextField
                        errorMessage={firstNameError}
                        id="firstName"
                        label="First Name"
                        className="mr10 flex1"
                        styles={{ fieldGroup: { height: '48px', border: 'none', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px inset' }, field: { height: '46px' } }}
                        value={firstName}
                        onChange={handleFirstnameChange}
                    />
                    <TextField
                        styles={{ fieldGroup: { height: '48px', border: 'none', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px inset' }, field: { height: '46px' } }}
                        errorMessage={lastNameError}
                        id="lastName"
                        className=" flex1"
                        label="Last Name"
                        value={lastName}
                        onChange={handleLastnameChange}
                    />
                </div>
                <div className="m-b-5" css={error(passwordError)}>
                    <TextField
                            styles={{ fieldGroup: { height: '48px', border: 'none', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px inset' }, field: { height: '46px', letterSpacing: '-.1em' } }}
                            errorMessage={passwordError}
                            id="password"
                            label="Password"
                            type="password"
                            value={password}
                            canRevealPassword
                            onChange={handlePasswordChange}
                            onBlur={(e) => {
                                if (!password_validate(password)) {
                                    setPasswordError('Password not strong enough.')
                                }
                            }}
                        />
                        <p className="label-small">Your password must contain at least 8 characters, one lower case letter, one number and one special character.</p>
                </div>
                <div className="mt15">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                        <UiCheckbox
                            checked={termsAccepted}
                            onChange={(e, data) => { setTermsAccepted(data.checked); setTermsError(false); }}
                        />
                        <span
                            onClick={() => { setTermsAccepted(!termsAccepted); setTermsError(false); }}
                            style={{ fontSize: 14, color: '#444', lineHeight: 1.4, cursor: 'pointer', userSelect: 'none' }}
                        >
                            I agree to Teamsly's{' '}
                            <a
                                href="https://teamsly.com/terms"
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                style={{ color: '#1a73e8' }}
                            >Terms of Service</a>{' '}
                            and{' '}
                            <a
                                href="https://teamsly.com/privacy"
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                style={{ color: '#1a73e8' }}
                            >Privacy Policy</a>
                        </span>
                    </div>
                    {termsError && <p style={{ color: 'var(--danger)', fontSize: 12, margin: '4px 0 0' }}>You must agree to the terms to continue.</p>}
                </div>
                <div>
                        <button type="submit" className="ms-Button ms-Button--primary mt15 continue width100" style={{ color: '#fff', border: 'none' }} disabled={loading}>
                            {loading ? <Spinner size={SpinnerSize.small} /> : 'Continue'}
                        </button>
                </div>
                <div className="m-t-15 text-center">
                        <p>Already a member? <Link to="/login"> Log in</Link></p>
                </div>
            </div>
            </form>
        </div>
    )
    
}
